import { render, staticRenderFns } from "./openBox.vue?vue&type=template&id=a0909b12&scoped=true"
import script from "./openBox.vue?vue&type=script&lang=js"
export * from "./openBox.vue?vue&type=script&lang=js"
import style0 from "./openBox.vue?vue&type=style&index=0&id=a0909b12&prod&lang=scss&scoped=true"
import style1 from "./openBox.vue?vue&type=style&index=1&id=a0909b12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0909b12",
  null
  
)

export default component.exports